import { useEffect, useState } from "react";
import { Box, Button, Input, Text, VStack, HStack, Badge } from "@chakra-ui/react";
import { showToast } from "@/components/ui/toaster";

const SettingsPage = () => {
    const [accessToken, setAccessToken] = useState('');
    const [isSet, setIsSet] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const fetchCurrentToken = async () => {
        try {
            const res = await fetch('/api/whatsapp/settings');
            if (res.ok) {
                const data = await res.json();
                const token = data.accessToken || '';
                setAccessToken(token);
                setIsSet(!!token);
            }
        } catch {
            // ignore
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { fetchCurrentToken(); }, []);

    const handleSave = async () => {
        if (!accessToken.trim()) return;
        setIsSaving(true);
        try {
            const res = await fetch('/api/whatsapp/settings', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accessToken: accessToken.trim() }),
            });
            if (res.ok) {
                showToast('Saved', 'WhatsApp access token updated.', 'success');
                setIsSet(true);
            } else {
                showToast('Error', `Failed to save: ${res.status}`, 'error');
            }
        } catch (err) {
            showToast('Error', 'Failed to save access token.', 'error');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <VStack w="full" alignItems="flex-start" rowGap={6}>
            <Text fontSize="xl" fontWeight="semibold">Settings</Text>
            <Box
                w="full"
                maxW="600px"
                bg="bg.card"
                borderWidth="1px"
                borderColor="border.primary"
                borderRadius="md"
                p={6}
            >
                <VStack alignItems="flex-start" rowGap={4}>
                    <HStack>
                        <Text fontWeight="medium">WhatsApp Access Token</Text>
                        {!isLoading && (
                            isSet ? (
                                <Badge colorPalette="green" variant="subtle" fontSize="xs">Set</Badge>
                            ) : (
                                <Badge colorPalette="red" variant="subtle" fontSize="xs">Not set</Badge>
                            )
                        )}
                    </HStack>

                    <Input
                        placeholder="Enter Meta WhatsApp access token"
                        value={accessToken}
                        onChange={(e) => setAccessToken(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                    />
                    <Button
                        variant="primary"
                        onClick={handleSave}
                        loading={isSaving}
                        disabled={!accessToken.trim()}
                    >
                        Save
                    </Button>
                </VStack>
            </Box>
        </VStack>
    );
};

export default SettingsPage;

